import React from "react";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import { DtvCompetitorTable } from "./dtv-competitor-table";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import DtvTabs from "@directv-digital/dds.ui.dtv-tabs";
import { fireTabHandleChange } from '@directv-digital/dds.services.analytics-service';

export interface DtvCompetitorTableModuleProps {
  id?: string;
  enableTabs?: boolean;
  isComparisonTable?: boolean;
  tabs?: TabsLabel[];
  tabAlign?: string;
  tabFontSize?: any;
  tabFontColor?: string;
  tabBgColor?: string;
  selectedTabFontColor?: string;
  selectedTabBgColor?: string;
};

interface TabsLabel {
    /**
    * CI configurable: Yes
    * DESC: Sets the label seen on the tab
    */
    label: {
      content: string;
    };
     /**
    * CI configurable: Yes
    * DESC: Configures table shown under each tab when associated tab is clicked
    */
    table: any;
}

export const DtvCompetitorTableModule = (props: DtvCompetitorTableModuleProps) => {
  try {
    const { id, enableTabs, tabs, tabAlign } = props;
    const propsData: any = !enableTabs && (tabs && tabs.length > 0 ? tabs[0].table : props);
    // When enableTabs=true, propsData is `false` (not undefined), so `false?.isComparisonTable` → undefined,
    // which correctly falls through to `props?.isComparisonTable` then the default of `true`.
    const isComparisonTable: boolean = propsData?.isComparisonTable ?? props?.isComparisonTable ?? true;
    const onTabChange = tabIndex => {
      const linkName = tabs?.[tabIndex]?.label?.content
      const analyticsData = {
        linkName: `/${linkName?.toLowerCase()}`,
        linkPosition: 'dtv-competitor-table',
        linkDestination: `/tab/${linkName}`
      }
      fireTabHandleChange(analyticsData);
    };

    return (<DtvBox
            id={id}
            sx={{
              m: {
                  md: "0 140px 0 140px",
                  lg: "0 140px 0 140px",
                  xl: "0 140px 0 140px",
                  xs: isComparisonTable ? "0 0 0 20px" : "0 20px 0 20px",
                  sm: isComparisonTable ? "0 0 0 32px" : "0 32px 0 32px"
              }
          }}
        >
        {enableTabs ? <>
          <DtvTabs
            id={`${id}-tab-panel`}
            position={tabAlign} selectedTabBgColor={props?.selectedTabBgColor}
            selectedTabFontColor={props?.selectedTabFontColor}
            tabBgColor={props?.tabBgColor}
            tabFontColor={props?.tabFontColor}
            tabFontSize={props?.tabFontSize}
            tabVariant={"competitorTableTabs"}
            tabsLabel={tabs?.slice(0, 4)}
            onChange={onTabChange}
          >
            {tabs?.map((tab, tabIndex) => {
              const { table } = tab;
              const tabTable = Array.isArray(table) ? table : [table];
              return (
                <DtvBox
                  key={`${id}-${tabIndex}`}
                >
                  <DtvCompetitorTable
                    id={id}
                    {...tabTable[0]}
                  />
                </DtvBox>
              );
            })}
          </DtvTabs>
        </> : <DtvBox>
          <DtvCompetitorTable
            {...props}
            {...propsData}
          />
        </DtvBox>}
    </DtvBox>)
  } catch(error) {
    return <ErrorDisplay component="DtvCompetitorTableModule" error={error} />;
  }
}
